var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-instance-1{fill:#aecbfa;}.cls-instance-2{fill:#669df6;}.cls-instance-3{fill:#4285f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_ComputeEngine_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-1",
    x: 9,
    y: 9,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-2",
    x: 11,
    y: 2,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-2",
    x: 7,
    y: 2,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-2",
    x: 15,
    y: 2,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-3",
    x: 11,
    y: 18,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-3",
    x: 7,
    y: 18,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-3",
    x: 15,
    y: 18,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-3",
    x: 19,
    y: 10,
    width: 2,
    height: 4,
    transform: "translate(8 32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-3",
    x: 19,
    y: 14,
    width: 2,
    height: 4,
    transform: "translate(4 36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-3",
    x: 19,
    y: 6,
    width: 2,
    height: 4,
    transform: "translate(12 28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-2",
    x: 3,
    y: 10,
    width: 2,
    height: 4,
    transform: "translate(-8 16) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-2",
    x: 3,
    y: 14,
    width: 2,
    height: 4,
    transform: "translate(-12 20) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-instance-2",
    x: 3,
    y: 6,
    width: 2,
    height: 4,
    transform: "translate(-4 12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-instance-1",
    d: "M5,5V19H19V5ZM17,17H7V7H17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-instance-2",
    points: "9 15 15 15 12 12 9 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-instance-3",
    points: "12 12 15 15 15 9 12 12"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstance);
export default __webpack_public_path__ + "static/media/instance.832d35e209f045fdf725308c3d723a2b.svg";
export { ForwardRef as ReactComponent };